import { render, staticRenderFns } from "./InterventionCreate.vue?vue&type=template&id=c9053da6&"
import script from "./InterventionCreate.vue?vue&type=script&lang=js&"
export * from "./InterventionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports